export const REQUEST_INITIAL = 'initial';
export const REQUEST_INPROGRESS = 'inprogress';
export const REQUEST_SUCCESS = 'success';
export const REQUEST_ERROR = 'error';

/**
 * Lists request statuses that should prevent duplicate requests from firing,
 * includes in progress (to prevent another request),
 *  and success (cause then another request is not required)
 */
export const RequestFiredStatusList = [REQUEST_INPROGRESS, REQUEST_SUCCESS];

export const DELIVERY_TYPE_TAKEAWAY = 'takeaway';
export const DELIVERY_TYPE_COURIER = 'courier';

export const MAIN_CONTAINER_ID = 'react-container';
export const LOCAL_STORAGE_DATA_KEY = 'redux';

export const FOLLOW_LINK = 'followLink';
export const ORIGIN_COOKIE_NAME = 'origin';
